import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetFilteredInstalledProductsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.Installed_Products_Bool_Exp>;
}>;


export type GetFilteredInstalledProductsQuery = { __typename?: 'query_root', installed_products: Array<{ __typename?: 'installed_products', id: any, product_id: any, property_id: any, installation_date: any, warranty_expiration_date?: any | null, warranty_status: string, product_serial?: string | null, location?: string | null, building_id?: any | null, floor_id?: any | null, room_id?: any | null, in_room_location?: any | null, partition_id?: string | null, photo_link?: string | null, device_status?: string | null, partner_disconnected_at?: any | null, partner_association?: string | null, building?: { __typename?: 'buildings', id: any, name: string } | null, floor?: { __typename?: 'floors', id: any, name: string } | null, room?: { __typename?: 'rooms', id: any, name: string } | null, product: { __typename?: 'products', id: any, name: string, description: string, sku?: string | null, make: string, model: string, photo_link?: string | null, product_category: { __typename?: 'product_categories', name: string, label: string } }, property?: { __typename?: 'properties', id: any, name: string, partner_association?: string | null, partner_id?: string | null } | null }>, product_categories: Array<{ __typename?: 'product_categories', name: string, label: string }> };


export const GetFilteredInstalledProductsDocument = gql`
    query getFilteredInstalledProducts($where: installed_products_bool_exp) {
  installed_products(where: $where, order_by: {property_id: asc}) {
    id
    product_id
    property_id
    installation_date
    warranty_expiration_date
    warranty_status
    product_serial
    location
    building_id
    floor_id
    room_id
    in_room_location
    building {
      id
      name
    }
    floor {
      id
      name
    }
    room {
      id
      name
    }
    partition_id
    photo_link
    device_status
    partner_disconnected_at
    partner_association
    product {
      id
      name
      description
      sku
      product_category {
        name
        label
      }
      make
      model
      photo_link
    }
    property {
      id
      name
      partner_association
      partner_id
    }
  }
  product_categories {
    name
    label
  }
}
    `;

/**
 * __useGetFilteredInstalledProductsQuery__
 *
 * To run a query within a React component, call `useGetFilteredInstalledProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilteredInstalledProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilteredInstalledProductsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetFilteredInstalledProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetFilteredInstalledProductsQuery, GetFilteredInstalledProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilteredInstalledProductsQuery, GetFilteredInstalledProductsQueryVariables>(GetFilteredInstalledProductsDocument, options);
      }
export function useGetFilteredInstalledProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilteredInstalledProductsQuery, GetFilteredInstalledProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilteredInstalledProductsQuery, GetFilteredInstalledProductsQueryVariables>(GetFilteredInstalledProductsDocument, options);
        }
export function useGetFilteredInstalledProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFilteredInstalledProductsQuery, GetFilteredInstalledProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFilteredInstalledProductsQuery, GetFilteredInstalledProductsQueryVariables>(GetFilteredInstalledProductsDocument, options);
        }
export type GetFilteredInstalledProductsQueryHookResult = ReturnType<typeof useGetFilteredInstalledProductsQuery>;
export type GetFilteredInstalledProductsLazyQueryHookResult = ReturnType<typeof useGetFilteredInstalledProductsLazyQuery>;
export type GetFilteredInstalledProductsSuspenseQueryHookResult = ReturnType<typeof useGetFilteredInstalledProductsSuspenseQuery>;
export type GetFilteredInstalledProductsQueryResult = Apollo.QueryResult<GetFilteredInstalledProductsQuery, GetFilteredInstalledProductsQueryVariables>;